export const BASE_CONF = {
    gutterWidth: 1,
    outerMargin: 2,
    container: {
        sm: 46,
        md: 61,
        lg: 76,
    },
    breakpoints: {
        xs: 0,
        sm: 48,
        md: 64,
        lg: 75,
    },
};
export const DIMENSION_NAMES = ['xs', 'sm', 'md', 'lg'];
//# sourceMappingURL=config.js.map